import { create } from 'zustand';
import { m } from '../utils/dateUtils';
import { 
    sendResetOperationalMapMode,
    sendOperationalMapDateRange,
    sendOperationalMapMode
} from '../channels/operationalMapChannel';

export const useOperationalMapStore = create((set) => ({

    isOperationalMapMode: false,

    operationalMapDateRange: {
        startDate: m(),
        endDate: m()
    },

    setOperationalMapMode: (enabled, broadcast = true) => {

        const isOperationalMapMode = Boolean(enabled);

        set({
            isOperationalMapMode
        });

        if (broadcast) {
            
            sendOperationalMapMode(isOperationalMapMode);
        }
    },

    setOperationalMapDateRange: (startDate, endDate, broadcast = true) => {

        const operationalMapDateRange = {
            startDate: startDate.clone(),
            endDate: endDate.clone()
        };

        set({
            operationalMapDateRange
        });

        if (broadcast) {

            sendOperationalMapDateRange({
                startDate:
                    operationalMapDateRange
                        .startDate
                        .format('YYYY-MM-DD'),

                endDate:
                    operationalMapDateRange
                        .endDate
                        .format('YYYY-MM-DD')
            });
        }
    },

    reset: (broadcast = true) => {

        const operationalMapDateRange = {
            startDate: m(),
            endDate: m()
        };

        set({
            isOperationalMapMode: false,
            operationalMapDateRange
        });

        if(broadcast) {
            sendResetOperationalMapMode();
        }
    }

}));